import CertifySection from "../../components/Certify/CertifySection";
import Page from "../../finwell/pages/Page";

const CertifyPage = () => {
    return (
        <Page>
            <CertifySection />
        </Page>
    );
}

export default CertifyPage;